import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
export function getId() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (_isEmpty(entity)) {
    return null;
  }
  return _get(entity, '_id') || _get(entity, 'id');
}